export { PERMIT2_ADDRESS } from '@uniswap/permit2-sdk'
import { BigNumber } from 'ethers'

type ChainConfig = {
  router: string
  creationBlock: number
  weth: string
}

const WETH_NOT_SUPPORTED_ON_CHAIN = '0x0000000000000000000000000000000000000000'

const CHAIN_CONFIGS: { [key: number]: ChainConfig } = {
  // mainnet
  [1]: {
    router: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
    weth: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    creationBlock: 17143817,
  },
  // goerli
  [5]: {
    router: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
    weth: '0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6',
    creationBlock: 8940568,
  },
  // sepolia
  [11155111]: {
    router: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
    weth: '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14',
    creationBlock: 3543575,
  },
  // polygon
  [137]: {
    router: '0x643770E279d5D0733F21d6DC03A8efbABf3255B4',
    weth: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    creationBlock: 46866777,
  },
  //polygon mumbai
  [80001]: {
    router: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
    weth: '0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889',
    creationBlock: 35176052,
  },
  //optimism
  [10]: {
    router: '0xeC8B0F7Ffe3ae75d7FfAb09429e3675bb63503e4',
    weth: '0x4200000000000000000000000000000000000006',
    creationBlock: 108825869,
  },
  // optimism goerli
  [420]: {
    router: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
    weth: '0x4200000000000000000000000000000000000006',
    creationBlock: 8887728,
  },
  // arbitrum
  [42161]: {
    router: '0xeC8B0F7Ffe3ae75d7FfAb09429e3675bb63503e4',
    weth: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    creationBlock: 125861718,
  },
  // arbitrum goerli
  [421613]: {
    router: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
    weth: '0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3',
    creationBlock: 18815277,
  },
  // celo
  [42220]: {
    router: '0x88a3ED7F21A3fCF6adb86b6F878C5B7a02D20e9b',
    weth: WETH_NOT_SUPPORTED_ON_CHAIN,
    creationBlock: 21116361,
  },
  // celo alfajores
  [44787]: {
    router: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
    weth: WETH_NOT_SUPPORTED_ON_CHAIN,
    creationBlock: 17566658,
  },
  // binance smart chain
  [56]: {
    router: '0xeC8B0F7Ffe3ae75d7FfAb09429e3675bb63503e4',
    weth: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    creationBlock: 31254967,
  },
  // avalanche
  [43114]: {
    router: '0x82635AF6146972cD6601161c4472ffe97237D292',
    weth: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
    creationBlock: 34491144,
  },
  // base goerli
  [84531]: {
    router: '0xd0872d928672ae2ff74bdb2f5130ac12229cafaf',
    weth: '0x4200000000000000000000000000000000000006',
    creationBlock: 6915289,
  },
  // base mainnet
  [8453]: {
    router: '0xeC8B0F7Ffe3ae75d7FfAb09429e3675bb63503e4',
    weth: '0x4200000000000000000000000000000000000006',
    creationBlock: 3229053,
  },
  // dbk
  [20240603]: {
    router: '0x12ceb76d88a5303fe270946a3654dca0ddf77cea',
    weth: '0x4200000000000000000000000000000000000006',
    creationBlock: 1106015,
  },
  // berachain
  [80094]: {
    router: '0xe0847747a8570ae9916ab00b7991518bf958897b',
    weth: '0x6969696969696969696969696969696969696969',
    creationBlock: 1106015,
  },
  // hyperliquid
  [999]: {
    router: '0xf5cae0a166fe2a8315a3fd7dac974f08c50ed3c6',
    weth: '0x5555555555555555555555555555555555555555',
    creationBlock: 1106015,
  },
  // Sonic
  [146]: {
    router: '0xE0847747A8570ae9916Ab00b7991518Bf958897B',
    weth: '0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38',
    creationBlock: 9157175,
  },
  // Katana
  [747474]: {
    router: '0x8c245593eB9dBfE2Eb565A4AF4b7C691A7e7bb4D',
    weth: '0x4200000000000000000000000000000000000006',
    creationBlock: 3425961,
  },
  // Mitosis
  [124816]: {
    router: '0x8c245593eB9dBfE2Eb565A4AF4b7C691A7e7bb4D',
    weth: '0x124816325006f97E7136942B134a9545D95b05Fa',
    creationBlock: 924693,
  },
  // Somnia
  [5031]: {
    router: '0x8c245593eB9dBfE2Eb565A4AF4b7C691A7e7bb4D',
    weth: '0x046EDe9564A72571df6F5e44d0405360c0f4dCab',
    creationBlock: 88782595,
  },
  // 0G
  [16661]: {
    router: '0xe79B784ebe7D814225102d27f60DA7B923DfAA5F',
    weth: '0x1Cd0690fF9a693f5EF2dD976660a8dAFc81A109c',
    creationBlock: 1,
  },
  // Plasma
  [9745]: {
    router: '0xF5CAE0A166fe2a8315a3FD7DaC974F08c50ed3C6',
    weth: '0x6100E367285b01F48D07953803A2d8dCA5D19873',
    creationBlock: 1,
  },
  // Monad Testnet
  [10143]: {
    router: '0xFAAa2517A249E75F7eab1f71BFb858039646689f',
    weth: '0x760AfE86e5de5fa0Ee542fc7B7B713e1c5425701',
    creationBlock: 1,
  },
  // Monad
  [143]: {
    router: '0x12CeB76d88a5303Fe270946a3654Dca0dDF77CEA',
    weth: '0x3bd359C1119dA7Da1D913D1C4D2B7c461115433A',
    creationBlock: 37331225,
  },
  // MegaETH
  [4326]: {
    router: '0x8C0ad2e65608eCD5f0384584E16d38bf981521E3',
    weth: '0x4200000000000000000000000000000000000006',
    creationBlock: 1,
  },
  // Stable
  [988]: {
    router: '0x451D6e589a381E79f3EDc0Eed5eF2f3Ce51482E6',
    weth: '0x817997Ca8394E26CCE3dE3A076a4889b27DbF9dE',
    creationBlock: 3556490,
  },
}

export const UNIVERSAL_ROUTER_ADDRESS = (chainId: number): string => {
  if (!(chainId in CHAIN_CONFIGS)) throw new Error(`Universal Router not deployed on chain ${chainId}`)
  return CHAIN_CONFIGS[chainId].router
}

export const UNIVERSAL_ROUTER_CREATION_BLOCK = (chainId: number): number => {
  if (!(chainId in CHAIN_CONFIGS)) throw new Error(`Universal Router not deployed on chain ${chainId}`)
  return CHAIN_CONFIGS[chainId].creationBlock
}

export const WETH_ADDRESS = (chainId: number): string => {
  if (!(chainId in CHAIN_CONFIGS)) throw new Error(`Universal Router not deployed on chain ${chainId}`)

  if (CHAIN_CONFIGS[chainId].weth == WETH_NOT_SUPPORTED_ON_CHAIN) throw new Error(`Chain ${chainId} does not have WETH`)

  return CHAIN_CONFIGS[chainId].weth
}

// export const PERMIT2_ADDRESS = '0xdd8ef627dc2ad180eadd52f677dc5baad99acc9e' // TODO: make this shit multichain

export const CONTRACT_BALANCE = BigNumber.from(2).pow(255)
export const ETH_ADDRESS = '0x0000000000000000000000000000000000000000'
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
export const MAX_UINT256 = BigNumber.from(2).pow(256).sub(1)
export const MAX_UINT160 = BigNumber.from(2).pow(160).sub(1)

export const SENDER_AS_RECIPIENT = '0x0000000000000000000000000000000000000001'
export const ROUTER_AS_RECIPIENT = '0x0000000000000000000000000000000000000002'

export const OPENSEA_CONDUIT_SPENDER_ID = 0
export const SUDOSWAP_SPENDER_ID = 1
